import React, { Fragment, useState, useMemo } from "react";
import I18n from "i18n-js";

import { formatDate } from "../../services/date";

import Table from "./Table";
import Indicator from "./Indicator";
import TeamHealthScoreDetailsModal from "./TeamHealthScoreDetailsModal";

const TeamHealthScoreTable = ({ data, loading }) => {

  const previousResultsDate = formatDate(data.previous_results_date);
  const currentResultsDate = formatDate(data.current_results_date);

  const columns = useMemo(() => [
    {
      id: "title",
      accessorKey: "title",
      header: () => <span>{I18n.t("dashboard.overall_health.title")}</span>,
      cell: () => "",
      enableSorting: false
    },
    {
      id: "previous_value",
      accessorKey: "previous_value",
      header: () => <span>{previousResultsDate}</span>,
      cell: info => parseFloat(info.getValue()).toFixed(3),
      enableSorting: false
    },
    {
      id: "current_value",
      accessorKey: "current_value",
      header: () => <span>{currentResultsDate}</span>,
      cell: info => (
        <span>
          <Indicator indicator={info.row.original?.indicator} />
          {parseFloat(info.getValue()).toFixed(3)}
        </span>
      ),
      enableSorting: false
    }
  ], [previousResultsDate, currentResultsDate]);

  const [ths, setThs] = useState(null);

  const openDetails = (row) => setThs(row);

  const handleDetailsClose = () => setThs(null)

  return (
    <Fragment>
      <Table
        columns={columns}
        data={data?.kpis}
        loading={loading}
        onRowClick={openDetails}
      />
      <TeamHealthScoreDetailsModal {...ths} onClose={handleDetailsClose} />
    </Fragment>
  );
}

export default TeamHealthScoreTable;
